/* eslint-disable react/prop-types */
import React from "react";
import { connect, useSelector } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import { checkIfStoryPublic } from "../../../access-type-utils";
import { Paywall } from "../../pages/subscription-page/paywall";
import { SectionName } from "../../atoms/section-tag";
import { Headline } from "../../atoms/headline";
import { Subheadline } from "../../atoms/subheadline";
import Loader from "../../atoms/loader";
import { Authors } from "../../atoms/author";
import { socialShareSupport } from "../../molecules/social-share";
import { StoryCard, getJSEmbedElement } from "../../molecules/story-card";
import { StoryTags } from "../../atoms/social-tags";
import { SubscriptionCTA } from "../../molecules/subscription-cta";
import { CommentWidget } from "../../comment-widget";
import { AmazonPolly } from "../../molecules/amazon-polly/amazon-polly";
import { SaveButton } from "../../molecules/save-button";
import StopPress from "../../molecules/stop-press";
// import LoadingIcon from "../../../../assets/images/loader.svg";

import "./podcast.m.css";
import { GiftStoryButton } from "../../molecules/gift-story-button";

const PodcastStoryTemplate = props => {
  const hasActiveSubscription = useSelector(state =>
    get(state, ["fetchSubscription", "isActive"], null)
  );
  const firstPodcast =
    (props.story.cards &&
      props.story.cards
        .reduce((acc, element) => {
          acc = acc.concat(element["story-elements"]);
          return acc;
        }, [])
        .find(
          ({ type, subtype }) => type === "jsembed" || subtype === "jsembed"
        )) ||
    {};

  const isStoryPublic = checkIfStoryPublic(props.story);

  const story = isStoryPublic
    ? props.story
    : hasActiveSubscription
    ? props.story
    : props.newStory;
  const storyCards = get(story, ["cards"], []);

  const HeaderPlayer = props => {
    return getJSEmbedElement(isStoryPublic, firstPodcast, firstPodcast.id);
  };

  function getStoryCards(cards = [], story, config, hasActiveSubscription) {
    return cards.map((card, index) => {
      const getSubscriptionCTA = get(
        card,
        ["metadata", "attributes", "subscriptioncta", 0],
        "No"
      );
      const getNewsletter = get(
        card,
        ["metadata", "attributes", "newsletter", 0],
        null
      );
      const getNewsletterStoryCard = () => {
        return getNewsletter ? (
          <div className="newsletter-grid">
            <StoryCard
              key={index}
              card={card}
              story={story}
              config={config}
              firstVideoElementID={firstPodcastId}
            />
            <div className="story-card">
              <StopPress planName={getNewsletter} />
            </div>
          </div>
        ) : (
          <StoryCard
            key={index}
            card={card}
            story={story}
            config={config}
            firstVideoElementID={firstPodcastId}
          />
        );
      };
      if (getSubscriptionCTA === "Yes") {
        return (
          <React.Fragment>
            {getNewsletterStoryCard()}
            {!hasActiveSubscription ? (
              <div className="story-card">
                <SubscriptionCTA url={story.slug} />{" "}
              </div>
            ) : null}
          </React.Fragment>
        );
      }
      return getNewsletterStoryCard();
    });
  }

  function showStoryCards(storyCards, config, story, hasActiveSubscription) {
    return (
      <>
        {getStoryCards(storyCards, story, config, hasActiveSubscription)}
        <div className="story-tags">
          <StoryTags story={story} />
        </div>
        {!hasActiveSubscription && checkIfStoryPublic(story) && (
          <div className="story-subscription">
            {<SubscriptionCTA url={story.slug} />}
          </div>
        )}
        <div className="metype-widget">
          <CommentWidget story={story} />
        </div>
      </>
    );
  }

  function getIfNoAccess(
    storyCards,
    config,
    story,
    hasActiveSubscription,
    member
  ) {
    const noOfVisibleCards = get(config, [
      "layout",
      "no-of-visible-cards-in-a-blocked-story"
    ]);
    // console.log(member !== null && hasActiveSubscription === null);
    const eligibleCards = storyCards.slice(0, noOfVisibleCards);
    return (
      <>
        <div>
          {getStoryCards(eligibleCards, story, config, hasActiveSubscription)}
        </div>
        {member !== null && hasActiveSubscription === null ? (
          <div
            style={{
              display: "flex",
              height: "100px",
              flexDirection: "row",
              alignContent: "strech",
              justifyContent: "space-around"
            }}
          >
            <Loader color="#ec2227" />
          </div>
        ) : (
          <Paywall url={story.slug} {...props} />
        )}
      </>
    );
  }

  function getIfHasAccess(storyCards, config, story, hasActiveSubscription) {
    return showStoryCards(storyCards, config, story, hasActiveSubscription);
  }

  function handleAccess(
    storyCards,
    config,
    story,
    hasActiveSubscription,
    member
  ) {
    if (hasActiveSubscription) {
      return getIfHasAccess(storyCards, config, story, hasActiveSubscription);
    }
    return getIfNoAccess(
      storyCards,
      config,
      story,
      hasActiveSubscription,
      member
    );
  }

  const { id: firstPodcastId = -1 } = firstPodcast;

  return (
    <div styleName="podcast-story-wrapper">
      <div styleName="story-heading">
        <HeaderPlayer story={story} />
      </div>
      <div styleName="story-heading">
        <div styleName="section">
          <SectionName story={story} />
        </div>
        <Headline story={story} isStoryPage />
        <Subheadline story={story} />
        <div>
          {isStoryPublic || hasActiveSubscription ? (
            <AmazonPolly story={story} />
          ) : null}
        </div>
        <div>
          <Authors story={story} />
          &nbsp;
          <span style={{ verticalAlign: "middle" }}>
            &nbsp;&nbsp;&nbsp;
            <SaveButton story={story} />
            &nbsp;
          </span>
          {!isStoryPublic && hasActiveSubscription ? (
            <GiftStoryButton story={story} />
          ) : null}
        </div>
      </div>
      <div styleName="story-content">
        <div styleName="social-share-icons">
          <div styleName="sticky">{socialShareSupport(story)}</div>
        </div>
        <div styleName="story-cards">
          {isStoryPublic
            ? showStoryCards(
                storyCards,
                props.config,
                story,
                hasActiveSubscription
              )
            : handleAccess(
                storyCards,
                props.config,
                story,
                hasActiveSubscription,
                props.member
              )}
        </div>
      </div>
    </div>
  );
};

PodcastStoryTemplate.propTypes = {
  story: PropTypes.shape({
    cards: PropTypes.array
  }),
  member: PropTypes.object,
  config: PropTypes.object,
  hasSubscription: PropTypes.bool
};

class PodcastStoryBase extends React.Component {
  render() {
    return <PodcastStoryTemplate {...this.props} />;
  }
}

PodcastStoryBase.propTypes = {
  config: PropTypes.object
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {}),
  member: get(state, ["member"], null),
  hasSubscription: get(state, ["isSubscribedUser", "userHasSubscription"], null)
});

export const Podcast = connect(mapStateToProps)(PodcastStoryBase);
